import React from "react";
import { Link2, Type } from "lucide-react";
import { useComposerContext } from "../context/ComposerContext";

export default function ButtonSettingsPopover({ onApply }) {
  const { buttonPopover, setButtonPopover, buttonPopoverRef } = useComposerContext();

  if (!buttonPopover.open) return null;

  const handleApply = () => {
    onApply({ text: buttonPopover.text, url: buttonPopover.url });
    setButtonPopover((prev) => ({ ...prev, open: false }));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleApply();
    if (e.key === "Escape") setButtonPopover((prev) => ({ ...prev, open: false }));
  };

  return (
    <div
      ref={buttonPopoverRef}
      data-bc-popover
      className="fixed z-[95] w-[calc(100vw-2rem)] sm:w-64 bg-white border border-bookish-purple/15 rounded-2xl shadow-xl p-3 space-y-3"
      style={{ top: buttonPopover.top, left: Math.min(Math.max(8, buttonPopover.left), window.innerWidth - 264) }}
    >
      <p className="text-[10px] font-semibold uppercase tracking-wider text-bookish-purple/50">Button Settings</p>

      <div>
        <label className="text-xs block mb-1 text-bookish-purple/60">
          <Type size={11} className="inline mr-1" />
          Button Text
        </label>
        <input
          type="text"
          value={buttonPopover.text}
          placeholder="e.g. Buy Now"
          onChange={(e) => setButtonPopover((prev) => ({ ...prev, text: e.target.value }))}
          onKeyDown={handleKeyDown}
          autoFocus
          className="w-full border border-bookish-purple/15 rounded-lg px-2.5 py-1.5 text-sm bg-white focus:ring-1 focus:ring-bookish-purple/30"
        />
      </div>

      <div>
        <label className="text-xs block mb-1 text-bookish-purple/60">
          <Link2 size={11} className="inline mr-1" />
          Link URL
        </label>
        <input
          type="url"
          value={buttonPopover.url}
          placeholder="https://example.com"
          onChange={(e) => setButtonPopover((prev) => ({ ...prev, url: e.target.value }))}
          onKeyDown={handleKeyDown}
          className="w-full border border-bookish-purple/15 rounded-lg px-2.5 py-1.5 text-sm bg-white focus:ring-1 focus:ring-bookish-purple/30"
        />
      </div>

      <button
        type="button"
        onClick={handleApply}
        className="w-full px-2.5 py-1.5 text-xs font-medium rounded-lg bg-bookish-purple text-white hover:bg-bookish-purpleAccent transition-colors"
      >
        Apply
      </button>
    </div>
  );
}
